import Index from '../../views/affiliate/Index.vue';
import MyData from '../../views/affiliate/MyData.vue';
import IndicateProfessional from '../../views/affiliate/IndicateProfessional.vue';
import RegisterShopkeeper from '../../views/affiliate/RegisterShopkeeper.vue';
import Report from '../../views/affiliate/Report.vue';
import IndexDashboard from '../../views/affiliate/Dashboard/Index.vue';
import SalesPortfolio from '../../views/affiliate/SalesPortfolio.vue';
import UserTypes from '../../enums/UserTypes';

export default [
  {
    path: '/area-restrita/afiliado',
    name: 'afiliado',
    component: Index,
    children: [
      {
        path: '/area-restrita/afiliado/meus-dados',
        name: 'afiliado-meus-dados',
        component: MyData,
        meta: { userType: UserTypes.AFFILIATE },
      },
      {
        path: '/area-restrita/afiliado/cadastrar-lojista',
        name: 'afiliado-cadastrar-lojista',
        component: RegisterShopkeeper,
        meta: { userType: UserTypes.AFFILIATE },
      },
      {
        path: '/area-restrita/afiliado/indicar-profissional',
        name: 'afiliado-indicar-profissional',
        component: IndicateProfessional,
        meta: { userType: UserTypes.AFFILIATE },
      },
      {
        path: '/area-restrita/afiliado/relatorio',
        name: 'afiliado-relatorio',
        component: Report,
        meta: { userType: UserTypes.AFFILIATE },
      },
      {
        path: '/area-restrita/afiliado/dashboard',
        name: 'afiliado-dashboard',
        component: IndexDashboard,
        meta: { userType: UserTypes.AFFILIATE },
      },
      {
        path: '/area-restrita/afiliado/portfolio',
        name: 'afiliado-portfolio',
        component: SalesPortfolio,
        meta: { userType: UserTypes.AFFILIATE },
      },
    ],
  },
];
